module.exports = __webpack_public_path__ + "static/media/air-filter.0b745f88.svg";